import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useLang } from '../context/LangContext';
import { resolveImage } from '../config';

const ProductCard = ({ product }) => {
  const { dispatch, items } = useCart();
  const { t } = useLang();
  const [added, setAdded] = useState(false);
  const hasVariants = product.variantsCount > 0;
  const inCart = items.find(i => i.id === product.id);

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (hasVariants) return; // le choix du modèle se fait sur la fiche produit
    dispatch({ type: 'ADD_ITEM', payload: { ...product, price: parseFloat(product.price) || 0 } });
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  const originalPrice = Number(product.originalPrice);
  const hasOriginalPrice = Number.isFinite(originalPrice) && originalPrice > product.price;
  const discount = hasOriginalPrice
    ? Math.round((1 - product.price / originalPrice) * 100)
    : null;

  return (
    <div className="product-card">
      <Link to={`/product/${product.id}`} className="product-card__img-wrap" style={{ display: 'block', textDecoration: 'none' }}>
        <img src={resolveImage(product.image)} alt={product.name} loading="lazy" />
        {product.badge && (
          <span className={`product-badge product-badge--${product.badge.toLowerCase().replace(' ', '-')}`}>
            {product.badge}
          </span>
        )}
        {discount && <span className="discount-tag">-{discount}%</span>}
        <div className="product-card__overlay">
          <button className="quick-view-btn" onClick={e => e.preventDefault()}>{t('quick_view')}</button>
        </div>
      </Link>

      <div className="product-card__body">
        <p className="product-card__category">{product.category}</p>
        <Link to={`/product/${product.id}`} style={{ textDecoration: 'none' }}>
          <h3 className="product-card__name">{product.name}</h3>
        </Link>
        <p className="product-card__desc">{product.description}</p>
        {hasVariants && (
          <p className="product-card__variants-tag">🎯 {product.variantsCount} modèles disponibles</p>
        )}

        <div className="product-card__rating">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <span key={i} className={i < Math.floor(product.rating) ? 'star star--full' : 'star star--empty'}>★</span>
            ))}
          </div>
          <span className="rating-score">{product.rating}</span>
          {product.reviews > 0 && (
            <span className="rating-count">({product.reviews.toLocaleString()})</span>
          )}
        </div>

        <div className="product-card__footer">
          <div className="product-card__price">
            <span className="price-current">{product.price.toLocaleString()} TND</span>
            {hasOriginalPrice && (
              <span className="price-original">{originalPrice.toLocaleString()} TND</span>
            )}
          </div>
          {hasVariants ? (
            <Link to={`/product/${product.id}`} className="add-to-cart-btn">
              {t('choose_model')}
            </Link>
          ) : (
            <button
              className={`add-to-cart-btn ${added ? 'add-to-cart-btn--added' : ''} ${inCart ? 'add-to-cart-btn--in-cart' : ''}`}
              onClick={handleAdd}
            >
              {added ? t('added') : inCart ? `${t('in_cart')} (${inCart.quantity})` : t('add_to_cart')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
